<div class="admin-dashboard">

  <!-- Page header -->
  <div class="page-header">
    <div class="page-header__text">
      <h1 class="page-title">Dashboard</h1>
      <p class="page-subtitle">Manage and monitor the corpers.ng platform</p>
    </div>
    <div class="page-header__date">{{ today }}</div>
  </div>

  <!-- Quick info strip -->
  <div class="info-strip">
    <mat-icon class="info-strip__icon">info_outline</mat-icon>
    <span>Changes made here are applied immediately. Use caution when deleting or blocking accounts.</span>
  </div>

  <!-- Module cards -->
  <section>
    <p class="section-label">Platform modules</p>
    <div class="modules-grid">

      <a routerLink="/admin/users" class="module-card">
        <div class="module-card__icon-wrap module-card__icon-wrap--users">
          <mat-icon>people</mat-icon>
        </div>
        <div class="module-card__body">
          <div class="module-card__title">Users</div>
          <div class="module-card__desc">View, manage, block or delete corps members</div>
        </div>
        <mat-icon class="module-card__arrow">chevron_right</mat-icon>
      </a>

      <a routerLink="/admin/posts" class="module-card">
        <div class="module-card__icon-wrap module-card__icon-wrap--posts">
          <mat-icon>article</mat-icon>
        </div>
        <div class="module-card__body">
          <div class="module-card__title">Posts</div>
          <div class="module-card__desc">Moderate sales listings and accommodation posts</div>
        </div>
        <mat-icon class="module-card__arrow">chevron_right</mat-icon>
      </a>

      <a routerLink="/admin/ppas" class="module-card">
        <div class="module-card__icon-wrap module-card__icon-wrap--posts">
          <mat-icon>work</mat-icon>
        </div>
        <div class="module-card__body">
          <div class="module-card__title">PPAs</div>
          <div class="module-card__desc">Remove duplicate or bad PPAs, and restore recently deleted ones</div>
        </div>
        <mat-icon class="module-card__arrow">chevron_right</mat-icon>
      </a>

      <a routerLink="/admin/chats" class="module-card">
        <div class="module-card__icon-wrap module-card__icon-wrap--chats">
          <mat-icon>chat</mat-icon>
        </div>
        <div class="module-card__body">
          <div class="module-card__title">Chats</div>
          <div class="module-card__desc">Manage national chat and post announcements</div>
        </div>
        <mat-icon class="module-card__arrow">chevron_right</mat-icon>
      </a>

      <a routerLink="/admin/referrals" class="module-card">
        <div class="module-card__icon-wrap module-card__icon-wrap--referrals">
          <mat-icon>emoji_events</mat-icon>
        </div>
        <div class="module-card__body">
          <div class="module-card__title">Referrals</div>
          <div class="module-card__desc">See corpers with the most successful invites</div>
        </div>
        <mat-icon class="module-card__arrow">chevron_right</mat-icon>
      </a>

    </div>
  </section>

</div>
